<template>
  <div id="app">
    <Toast />
    <router-view />
  </div>
</template>

<script>
  import HomeView from './views/HomeView.vue';
  import {apiRequest} from "../public/js/utils/funcoes";
  import {apiUrl} from "@/router/apiBackRoutes";

  export default {
    components: {
      HomeView,
    },
    mounted() {
      this.intervaloVerificacao = setInterval(() => {
        apiRequest('GET', apiUrl.usuarios.verificarToken)
      }, 7200000);
    },
    beforeUnmount() {
      clearInterval(this.intervaloVerificacao);
    }
  }
</script>
